module.exports = __webpack_public_path__ + "img/avalanche.d923b1f0.svg";